import React, {FC, useCallback, useMemo} from "react";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {Endpoints} from "@brg/api";
import {Image} from "../../components/ResizedImageEnhanced/styles";
import {MEDIA, useIsMobile} from "@brg/ui";

interface VotingCardProps {
    cardData: any
    collectionId?: string
}

const CardUpperDesc = styled.div`
  padding: 6px 8px;
  background: #F6C744;
  max-width: 100px;
  position: absolute;
  top: 0;
  right: 0;
  @media ${MEDIA.LAPTOP} {
    max-width: 92px;
  }
  @media ${MEDIA.TABLET} {
    max-width: 86px;
    padding: 4px 8px;
  }
  @media ${MEDIA.MOBILE} {
    max-width: 80px;
    padding: 4px 8px;
  }
`

const CardWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  
  img {
    height: auto;
  }
`

const RatingsNumber = styled.div`
  color: #151514;
  text-align: right;
  font-family: Oswald;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  text-align: center;
  @media ${MEDIA.LAPTOP} {
    font-size: 12px;
    line-height: 13px;
  }
  @media ${MEDIA.TABLET} {
    font-size: 11px;
  }
  @media ${MEDIA.MOBILE} {
    font-size: 10px;
  }
`

const CardDescription = styled.div`
  margin-top: 8px;
  color: #FEFEFE;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`

export const VotingCard: FC<VotingCardProps> = ({cardData, collectionId}) => {

    const {i18n: {language}} = useTranslation()
    const images = useMemo(() => cardData?.images || [], [cardData])
    const rating = useMemo(() => cardData?.rating || 0, [cardData])
    const title = useMemo(() => translateStrangeObject(cardData?.title, language), [cardData, language])
    const [image, ref] = useResizedImageEnhanced(images);
    const isMobile = useIsMobile();


    return <CardWrapper ref={ref}>
        <CardUpperDesc>
            <RatingsNumber>голосов: {rating}</RatingsNumber>
        </CardUpperDesc>
        <Image alt=" " src={`${Endpoints.files}/${image?.url}`} />
        {isMobile && <CardDescription>{rating}</CardDescription>}
    </CardWrapper>
}import React, {FC, useCallback, useMemo} from "react";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {Endpoints} from "@brg/api";
import {Image} from "../../components/ResizedImageEnhanced/styles";
import {MEDIA, useIsMobile} from "@brg/ui";

interface VotingCardProps {
    cardData: any
    collectionId?: string
}

const CardUpperDesc = styled.div`
  padding: 6px 8px;
  background: #F6C744;
  max-width: 100px;
  position: absolute;
  top: 0;
  right: 0;
  @media ${MEDIA.LAPTOP} {
    max-width: 92px;
  }
  @media ${MEDIA.TABLET} {
    max-width: 86px;
    padding: 4px 8px;
  }
  @media ${MEDIA.MOBILE} {
    max-width: 80px;
    padding: 4px 8px;
  }
`

const CardWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  
  img {
    height: auto;
  }
`

const RatingsNumber = styled.div`
  color: #151514;
  text-align: right;
  font-family: Oswald;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  text-align: center;
  @media ${MEDIA.LAPTOP} {
    font-size: 12px;
    line-height: 13px;
  }
  @media ${MEDIA.TABLET} {
    font-size: 11px;
  }
  @media ${MEDIA.MOBILE} {
    font-size: 10px;
  }
`

const CardDescription = styled.div`
  margin-top: 8px;
  color: #FEFEFE;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`

export const VotingCard: FC<VotingCardProps> = ({cardData, collectionId}) => {

    const {i18n: {language}} = useTranslation()
    const images = useMemo(() => cardData?.images || [], [cardData])
    const rating = useMemo(() => cardData?.rating || 0, [cardData])
    const title = useMemo(() => translateStrangeObject(cardData?.title, language), [cardData, language])
    const [image, ref] = useResizedImageEnhanced(images);
    const isMobile = useIsMobile();


    return <CardWrapper ref={ref}>
        <CardUpperDesc>
            <RatingsNumber>голосов: {rating}</RatingsNumber>
        </CardUpperDesc>
        <Image alt=" " src={`${Endpoints.files}/${image?.url}`} />
        {isMobile && <CardDescription>{rating}</CardDescription>}
    </CardWrapper>
}